<template>
  <v-card>
    <v-card-title> Testator </v-card-title>

    <v-card-text>
      <h4>Testator:</h4>
      <div v-if="testator.fullName">
        <p>
          {{ testator.fullName }} -
          {{
            testator.gender
              ? testator.gender.toLowerCase()
              : 'gender not specified'
          }}
        </p>
        <p v-if="testator.age">{{ testator.age }} years old</p>
      </div>
      <p v-else>No name provided yet</p>

      <v-row :no-gutters="$vuetify.breakpoint.mdAndDown">
        <v-col cols="12" lg="4">
          <h4>Contact number:</h4>
          <div v-if="testator.cellNumber">
            <p>{{ testator.cellNumber }}</p>
          </div>
          <p v-else>Not provided yet</p>
        </v-col>
        <v-col
          cols="12"
          lg="8"
          v-if="whitelabel.authentication.signUp.showEmail"
        >
          <h4>Email:</h4>
          <p>{{ testator.email }}</p>
        </v-col>
        <v-col
          cols="12"
          lg="8"
          v-if="whitelabel.authentication.signUp.showUniqueIdentifier"
        >
          <h4>Industry Number:</h4>
          <p>{{ testator.uniqueIdentifier }}</p>
        </v-col>
      </v-row>

      <v-row :no-gutters="$vuetify.breakpoint.smAndDown">
        <v-col cols="12" md="6" lg="4">
          <h4>Invite / Signup date</h4>
          <p>{{ testator.createdAt | date_DMMMYYYY }}</p>
        </v-col>
        <v-col cols="12" md="6" lg="4">
          <h4>Last login date</h4>
          <p v-if="testator.lastLogin">
            {{ testator.lastLogin | date_DMMMYYYY }}
          </p>
          <p v-else>n/a</p>
        </v-col>
        <v-col cols="12" md="6" lg="4">
          <h4>Last will download date</h4>
          <p v-if="lastWillDownloadDate">
            {{ lastWillDownloadDate | date_DMMMYYYY }}
          </p>
          <p v-else>n/a</p>
        </v-col>
      </v-row>

      <v-row>
        <v-col v-if="testator.advisor" cols="12" md="6">
          <h4>Advisor</h4>
          <p>{{ testator.advisor.fullName }} ({{ testator.advisor.email }})</p>
        </v-col>
        <v-col v-if="testator.company" cols="12" md="6">
          <h4>Company</h4>
          <p>{{ testator.company.tradingName }}</p>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <h4>Will country</h4>
          <p>{{ willCountry }}</p>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
  import { latestWillVersion } from '../../../constants/js/will-verification';

  export default {
    name: 'TestatorCard',
    props: {
      testator: {
        required: true,
        type: Object,
      },
      relations: {
        required: true,
        type: Object,
      },
    },
    computed: {
      lastWillDownloadDate() {
        const latestWill = latestWillVersion(this.testator.willVersions);
        return latestWill ? latestWill.createdAt : null;
      },
      willCountry() {
        return this.testator.willCountry == 'ZA'
          ? 'South Africa'
          : 'United Kingdom';
      },
    },
  };
</script>
